import * as types from '../mutation-types'
import userApi from '../../api/UserApi'
import auth from '../../utils/auth'

const state = {
  isAuth: auth.isTokenValid(),
  userInfo: auth.user
}

const getters = {
  isAuth: state => state.isAuth,
  getUser: state => state.userInfo
}

const actions = {
  async login ({ dispatch }, { email, password }) {
    try {
      const userObj = await userApi.login(email, password)
      dispatch('setUser', userObj)
      return userObj
    } catch (e) {
      dispatch('logout')
      return Promise.reject(e)
    }
  },

  refreshToken () {
    return userApi.refreshToken()
  },

  setUser ({ commit }, userObj) {
    commit(types.LOGIN_USER, userObj)
  },

  logout ({ commit }) {
    userApi.logout()
    commit(types.LOGOUT_USER)
  },

  async updateGdpr ({ commit }, value) {
    await userApi.updateGdpr(value)
    const user = await userApi.getUser()
    commit(types.UPDATE_GDPR, user.accepted_dpp)
  }
}

const mutations = {
  [types.LOGIN_USER] (state, userObj) {
    state.isAuth = Boolean(userObj)
    state.userInfo = userObj
  },
  [types.LOGOUT_USER] (state) {
    state.isAuth = false
    state.userInfo = null
  },
  [types.UPDATE_GDPR] (state, value) {
    state.userInfo.accepted_dpp = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
